import React, { useState, useEffect } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { glassWork, materialPricingSlice, materialPricingState, select } from './MaterialPricingSlice'
import { glassPrice, materialsSlice, materialsState } from '../MaterialsSlice'

// Gird system
import { Col, Row } from 'react-grid-system'

// Components
import Modal from '../../../components/Modal/Modal'
import { InputField, SelectField } from '../../../components/FormElements/FormElements'


import { SuccessMark, WhiteboxLoader, } from '../../../components/Loader/Loader'
import { useNotification } from '../../../services/usenotification'
import { havePermission } from '../../../services/hoc/permissions'
import { Divider } from '@mui/material'

import { useAPI } from '../../../services/hoc/useAPI'
interface iProps {addService:Function}
export default ({addService}:iProps) => {

    // Translation
    const t = useTranslation()
    const {alertError500,alert}=useNotification()

    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { material_pricing: materialPricingState }) => state.material_pricing)
    const materialState=useSelector(
        (state: { materials: materialsState }) => state.materials,
      );

    const ENDPOINTS = useAPI()


    const [serviceOptions, setServiceOptions] = useState<select[]>([])

    const toggle = () => {
        dispatch(materialPricingSlice.actions.setIsOpen(!state.isOpen))
        dispatch(materialPricingSlice.actions.init())
    }

    // Fetch Data
    const fetchData = (page: number, page_size: number = 10) => {
        dispatch(materialPricingSlice.actions.setIsLoading(true))

        ENDPOINTS.glasses().
        serviceNotPriced({ id: state.material?.id })
            .then((response: any) => {
                let services: glassWork[] = response.data.data[0].notpriced.map((service: any): glassWork => ({
                    id: service.id,
                    name: service.name,
                    code: service.code
                }))

                let options: select[] = response.data.data[0].notpriced.map((service: any): select => ({
                    label: service.name,
                    value: service.id
                }))

                setServiceOptions(options);


                dispatch(materialPricingSlice.actions.setIsLoading(false))
                dispatch(materialPricingSlice.actions.addServices(services))
                dispatch(materialsSlice.actions.setHasMore(page < Number(response.data.data.last_page)))

                // if (!state.isLoaded)
                //     dispatch(materialsSlice.actions.setIsLoaded(true))
            })
            .catch((error:any)=>{
                dispatch(materialPricingSlice.actions.setIsLoading(false))
                alertError500(error)
            })
    }
    const submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
       if(!havePermission("Show Service not Priced")) return
        dispatch(materialPricingSlice.actions.setIsLoading(true))
        ENDPOINTS.pricing()
        .addGlassPrices({ glass_id: parseInt(materialState.material?.id.toString()??'0'), prices: state.prices })
        .then((response: any) => {


            let glassPrices: glassPrice[] = response.data.data;
            
            dispatch(materialsSlice.actions.addGlassPrices(glassPrices))
            dispatch(materialPricingSlice.actions.setIsLoading(false))
            dispatch(materialPricingSlice.actions.setIsSuccess(true))
            setTimeout(() => {
                toggle()
                // dispatch(materialsSlice.actions.setMaterial({showMaterial: true, material:}))
                dispatch(materialPricingSlice.actions.setIsOpen(false))
            }, 1000);
        }).catch ((err:any)=>{
            dispatch(materialPricingSlice.actions.setIsLoading(false))
            alertError500(err)
        })
    }


    // First fetch
    useEffect(() => {
        // if (!state.isLoaded && !state.isFetching)
       if(havePermission("Show Service not Priced"))  {

            fetchData(1)
        }
    }, [materialState.material])

    return (
        <Modal open={state.isOpen} toggle={toggle}>
            {state.isLoading ? <WhiteboxLoader /> : ""}

            {state.isSuccess ? <SuccessMark /> : ""}

            <h2 className="text-center" style={{ margin: "0 0 20px" }}>{t("pricing")}</h2>

            <form onSubmit={submit} style={{ width: "450px" }}>

                {
                    state.prices.map((price, index) => (
                        <div className="attribute" key={index}>
                            <div className="attribute-fields" style={state.prices.length > 1 ? {} : { padding: 0 }}>
                                <Row style={{marginBlock:'5px'}}>
                                    <Col md={12}>
                                        <Col md={12} style={{margin:'0 auto'}} >
                                            <SelectField
                                                onMenuOpen={havePermission("Show Service not Priced")?()=>{}:()=>{
                                                    alert({en:"You don't have permission to show not priced service",
                                                ar:"لا تملك صلاحيات لعرض الخدمات الغير مسعرة"},'info')
                                                }}
                                                options={serviceOptions}
                                                value={serviceOptions.find(option => option.value === price.glass_work_id)}
                                                onChange={(option: { value: string }) =>
                                                dispatch(materialPricingSlice.actions.setService({ index, value: option.value }))}
                                                
                                            />
                                        </Col>
                                    </Col>

                                    <Col md={12}>
                                        <Col md={12} style={{margin:'0 auto'}}>

                                            <InputField
                                                type="number"
                                                label={t("price")}
                                                value={state.prices[index].price}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    dispatch(materialPricingSlice.actions.setPriceValue({ index, value: e.target.value }));
                                                }}
                                            // error={ showErrors && !attribute.hint ? t("required_error") : "" }
                                            />
                                        </Col>
                                    </Col>
                                    <Col xs={12}>
                                        <Divider variant='middle' sx={{background:'lightgray'}}  />
                                    </Col>
                                </Row>
                            </div>
                            {state.prices.length > 1 ? <i className="icon-delete" onClick={
                                () => {
                                  
                                    dispatch(materialPricingSlice.actions.deletePrice(index))
                                }
                            }></i> : ""}
                        </div>
                    ))
                }

                <div className="text-left">
                    <button className="button bg-white color-gold margin-top-30"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => 
                          {  e.stopPropagation()
                            e.preventDefault()
                            addService()
                        }
                            
                        }><i className='icon-plus'></i></button>
                </div>

                <button className="button round bg-gold color-white margin-top-20" style={{ padding: "0 80px", marginBottom: 5 }} >{t("submit")}</button>

            </form>

        </Modal>
    );
}